import { motion } from "framer-motion";
import { Heart, Shield, Lightbulb, TrendingUp, ArrowRight, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";
import { Link } from "react-router-dom";
import { useCmsSection } from "@/hooks/useCmsSection";

const icons = [Heart, Shield, Lightbulb, TrendingUp];

const WhyParticipateSection = () => {
  const { t, isRtl, lang } = useI18n();
  const Arrow = isRtl ? ArrowLeft : ArrowRight;
  const cms = useCmsSection("why");

  return (
    <section className="py-10 bg-background">
      <div className="container">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-secondary font-body font-semibold text-sm tracking-widest uppercase">{t.why.tag}</span>
          <h2 className="text-3xl md:text-5xl font-display font-bold mt-3 text-foreground">
            {lang === 'ar' ? (cms.title_ar ? cms.title_ar : <>{t.why.title1}<span className="text-gradient-warm">{t.why.titleHighlight}</span></>) : (cms.title_fr ? cms.title_fr : <>{t.why.title1}<span className="text-gradient-warm">{t.why.titleHighlight}</span></>)}
          </h2>
          <p className="mt-1.5 text-muted-foreground font-body max-w-2xl mx-auto text-lg">
            {lang === 'ar' ? (cms.subtitle_ar || t.why.description) : (cms.subtitle_fr || t.why.description)}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.why.reasons.map((reason, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={i}
                className="group p-6 rounded-xl bg-card shadow-card border border-border hover:shadow-elevated transition-all duration-300 hover:-translate-y-1"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <Icon className="w-6 h-6 text-primary group-hover:text-primary-foreground transition-colors" />
                </div>
                <h3 className="text-lg font-display font-semibold text-foreground mb-2">{reason.title}</h3>
                <p className="text-muted-foreground font-body text-sm leading-relaxed">{reason.description}</p>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          className="text-center mt-10"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Button variant="outline" size="lg" className="font-body font-semibold gap-2" asChild>
            <Link to="/pourquoi">
              {t.why.tag}
              <Arrow className="w-4 h-4" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default WhyParticipateSection;
